import { createSelector } from 'reselect';

export const viewModes = {
  classical: 0,
  recursive: 1,
};

export const getActiveViewMode = (state) => state.fileExplorer.activeViewMode;

export const getSelectedData = (state) => state.fileExplorer.selectedData;

export const getSelectedFolders = createSelector(
  [getSelectedData],
  (selection) => selection.filter((data) => data.entityType && data.entityType === 'folder'),
);

export const getSelectedDocuments = createSelector(
  [getSelectedData],
  (selection) => selection.filter((data) => data.entityType && data.entityType === 'document'),
);
